angular.module('TurneroApp').component('coCentrosAtencionModificar', {
    bindings: {
        ctrlPadre: '=',
    },
    controller: [
        '$mdDialog',
        'centrosAtencionService',
        'domicilioService',
        'unidadService',
        '$location',
        '$anchorScroll',
        'utilsService',
        'TurneroAppConstant',
        function ($mdDialog, centrosAtencionService, domicilioService, unidadService, $location, $anchorScroll, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.centroEditar = {};
            ctrl.Unidades = [];
            ctrl.domicilio = null;
            ctrl.sinDomicilio = false;
            ctrl.modificarClave = {};
            ctrl.zonas = {};

            ctrl.errores = {
                nombre: false,
                password: false,
                confirmacion: false,
                CUIT: false,
                calle: false,
                altura: false
            };

            ctrl.searchTermSede = {
                text: ''
            };
            ctrl.clearSearchTermSede = function () {
                ctrl.searchTermSede = {
                    text: ''
                };
            };

            ctrl.searchTerm = {
                text: ''
            };
            ctrl.clearSearchTerm = function () {
                ctrl.searchTerm = {
                    text: ''
                };
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadModificar = function (item) {
                    utilsService.swalTitle('Cargando Datos', 'info');
                    ctrl.Unidades = [];
                    ctrl.domicilio = null;
                    ctrl.sinDomicilio = false;
                    ctrl.modificarClave = {};

                    ctrl.errores = {
                        nombre: false,
                        password: false,
                        confirmacion: false,
                        CUIT: false,
                        calle: false,
                        
                    };

                    ctrl.CUITinfo = {
                        Id_Vin: "",
                        Encontrado: false
                    };

                    if (item && item.Id_Centro_Atencion) {
                        centrosAtencionService.getData({
                            'id_Centro_Atencion': item.Id_Centro_Atencion
                        }).$promise.then(function (data) {
                            ctrl.domicilio = null;
                            ctrl.tipoDerivaciones = [];
                            ctrl.centroEditar = data;
                            ctrl.centroEditar.grupoTipo = '';
                            ctrl.centroEditar.Direccion = {}
                            ctrl.centroEditar.Direccion.Sede_Domicilio = {}
                            ctrl.centroEditar.Direccion.Id_Sede = data.Sede.Id_Sede
                            ctrl.centroEditar.Direccion.Id_Zona = data.Sede.Id_Zona
                            ctrl.centroEditar.Direccion.Sede_Domicilio.Calle = data.Sede.Sede_Domicilio.Calle
                            ctrl.centroEditar.Direccion.Sede_Domicilio.Altura = data.Sede.Sede_Domicilio.Altura
                            ctrl.centroEditar.Direccion.Sede_Domicilio.CP = data.Sede.Sede_Domicilio.CP
                            if (data.CUIT != "") {
                                ctrl.centroEditar.grupoTipo = 'Empresa';
                                ctrl.centroEditar = ctrl.buscarCUIT(data.CUIT, ctrl.centroEditar);
                                ctrl.centroEditar = ctrl.ObtenerDomicilio(ctrl.centroEditar.Sede, 'Empresa', ctrl.centroEditar);
                            } else if (data.Id_Unidad != "") {
                                ctrl.centroEditar.Unidad = {
                                    Id_Unidad: data.Id_Unidad,
                                    N_Unidad: data.N_Unidad,
                                    Id_Domicilio: data.Id_Domicilio,
                                }
                                ctrl.centroEditar.grupoTipo = 'Unidad';
                                ctrl.centroEditar = ctrl.ObtenerDomicilio(ctrl.centroEditar.Unidad, 'Unidad', ctrl.centroEditar);
                            };

                            for (var i = 0; i < ctrl.centroEditar.Tipo_Derivacion.length; i++) {
                                var key = ctrl.centroEditar.Tipo_Derivacion[i].id;
                                var value = ctrl.centroEditar.Tipo_Derivacion[i].seleccionado ? 'S' : 'N'
                                ctrl.tipoDerivaciones[key] = value;
                            };

                            swal.close();
                        }).catch(function (error) {
                            utilsService.errores(error);
                        });
                    }
                }
            }

            ctrl.buscarCUIT = function (CUIT, centroData) {
                CUIT = CUIT.replace(/-/g, "");
                if (centroData.grupoTipo == 'Empresa') {
                    ctrl.domicilio = null;
                    if (CUIT != "") {
                        ctrl.errores.CUIT = false;
                        domicilioService.getPersonaJuridica({ 'CUIT': CUIT }, function (data) {
                            centroData.Id_Unidad = null
                            for (var i = 0; i < data.Sedes.length; i++) {
                                var sede = data.Sedes[i]
                                data.Sedes[i].text = sede.Id_Sede + ' - ' + sede.Sede_Domicilio.Calle + ' ' + sede.Sede_Domicilio.Altura + ' ' + sede.Sede_Domicilio.Torre + ' ' + sede.Sede_Domicilio.Depto + '-  ' + (sede.Sede_Domicilio.Barrio != '' ? sede.Sede_Domicilio.Barrio + ',' : '') + ' ' + sede.Sede_Domicilio.Localidad;
                            }
                            ctrl.CUITinfo = data;
                            ctrl.CUITinfo.Encontrado = true;
                            ctrl.zonas = ctrl.obtenerZonas()

                            if (centroData.Sede) {
                                centroData = ctrl.ObtenerDomicilio(centroData.Sede, 'Empresa', centroData);
                            }

                        }, function (error) {
                            if (error = 'SIN DATOS') {
                                ctrl.errores.CUIT = true;
                            } else {
                                utilsService.errores(error);
                            }
                        });
                    } else {
                        sweetAlert("Oops...", "El campo CUIT no puede estar vacío", "error");
                    }
                }

                return centroData;
            }

            ctrl.buscarUnidad = function (text) {
                if (text != "") {
                    unidadService.get({ 'texto': text }, function (data) {
                        ctrl.Unidades = data;
                    }, function (error) {
                        sweetAlert("Oops...", "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + error.data.ExceptionMessage + "</span>", "error");
                    });
                }
            };

            ctrl.ObtenerDomicilio = function (unidad, tipo, centroData) {
                ctrl.loading = true;
                if (unidad) {

                    if (tipo == 'Unidad') {

                        centroData.Id_Unidad = unidad.Id_Unidad;
                        centroData.N_Unidad = unidad.N_Unidad;
                        centroData.Sede = null;
                        centroData.CUIT = '';

                        if (unidad.Id_Domicilio) {
                            domicilioService.getDomicilio({ 'id_Vin': unidad.Id_Domicilio }, function (data) {

                                ctrl.sinDomicilio = false;
                                ctrl.domicilio = data;

                            }, function (error) {
                                ctrl.domicilio = null;
                                ctrl.Unidad = null;
                                utilsService.errores(error);


                            });
                        }
                        else {
                            ctrl.sinDomicilio = true;
                            ctrl.domicilio = null;
                        }
                    } else if (tipo == 'Empresa') {

                        centroData.Id_Unidad = null;
                        centroData.N_Unidad = null;

                        if (unidad.Sede_Domicilio != null) {
                            if (unidad.Sede_Domicilio.Calle) {
                                angular.forEach(centroData.Sede_Lista, function (el, k) {
                                    if (unidad.Id_Sede == el.Id_Sede) {
                                        ctrl.domicilio = el.Sede_Domicilio
                                    }
                                })
                            }
                        }
                    }
                }
                ctrl.loading = false;
                return centroData;
            }

            ctrl.agregaroQuitarDerivaciones = function (item) {
                ctrl.centroEditar.Tipos_Deriv_in = '';
                ctrl.centroEditar.Tipos_Deriv_out = '';

                angular.forEach(item, function (value, key) {
                    if (value == 'S') {
                        var existe = false;

                        for (var i = 0; i < ctrl.centroEditar.Tipo_Derivacion.length; i++) {
                            if (ctrl.centroEditar.Tipo_Derivacion[i].id == key && ctrl.centroEditar.Tipo_Derivacion[i].seleccionado == true) {
                                existe = true;
                                break
                            }
                        }
                        if (!existe)
                            ctrl.centroEditar.Tipos_Deriv_in = ctrl.centroEditar.Tipos_Deriv_in + key + ',';
                    }
                });

                angular.forEach(item, function (value, key) {
                    if (value != 'S') {
                        var existe = false;
                        var Id_Eliminar = "";
                        for (var i = 0; i < ctrl.centroEditar.Tipo_Derivacion.length; i++) {
                            if (ctrl.centroEditar.Tipo_Derivacion[i].id == key) {
                                if (ctrl.centroEditar.Tipo_Derivacion[i].seleccionado == true) {
                                    Id_Eliminar = ctrl.centroEditar.Tipo_Derivacion[i].id;
                                    existe = false;
                                    break
                                }
                                if (ctrl.centroEditar.Tipo_Derivacion[i].seleccionado == false) {
                                    existe = true;
                                    break
                                }
                            }
                        }

                        if (!existe)
                            ctrl.centroEditar.Tipos_Deriv_out = ctrl.centroEditar.Tipos_Deriv_out + Id_Eliminar + ',';
                    }
                });

                ctrl.centroEditar.Tipos_Deriv_in = ctrl.centroEditar.Tipos_Deriv_in.charAt(ctrl.centroEditar.Tipos_Deriv_in.length - 1) == ',' ?
                    ctrl.centroEditar.Tipos_Deriv_in.slice(0, -1) :
                    ctrl.centroEditar.Tipos_Deriv_in;

                ctrl.centroEditar.Tipos_Deriv_out = ctrl.centroEditar.Tipos_Deriv_out.charAt(ctrl.centroEditar.Tipos_Deriv_out.length - 1) == ',' ?
                    ctrl.centroEditar.Tipos_Deriv_out.slice(0, -1) :
                    ctrl.centroEditar.Tipos_Deriv_out;
            }

            ctrl.guardarCentroModificado = function () {
                ctrl.errores.nombre = !ctrl.centroEditar.N_Centro_Atencion;

                if (ctrl.errores.nombre) {
                    $location.hash('formCentro');
                    $anchorScroll();
                    return;
                }
                //modificar las derivaciones 
                ctrl.agregaroQuitarDerivaciones(ctrl.tipoDerivaciones);
                //Actualizar centro de atencion
                centrosAtencionService.update({ 'id': ctrl.centroEditar.Id_Centro_Atencion }, ctrl.centroEditar).$promise.then(function (res) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Modificar Centro de Atención", "El centro de atención se modificó correctamente", "success");
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            };


            //CAMBIAR CONTRASEÑA
            ctrl.Show_ChangePassword = function (ev) {
                $mdDialog.show({
                    template: require('./cambiarClaveCentro.html'),
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: false,
                    controllerAs: '$ctrl',
                    controller: function () {
                        return ctrl;
                    }
                })
            };

            ctrl.cambiarPassword = function () {

                ctrl.errores.password = !ctrl.modificarClave.Clave_Autogestion;
                ctrl.errores.confirmacion = !ctrl.modificarClave.confirmarPassword;

                if (ctrl.errores.password || ctrl.errores.confirmacion) {
                    return;
                }

                if (ctrl.modificarClave.confirmarPassword && ctrl.modificarClave.Clave_Autogestion) {
                    if (ctrl.modificarClave.confirmarPassword != ctrl.modificarClave.Clave_Autogestion) {
                        ctrl.errores.confirmacion = true;
                        return;
                    }
                }

                centrosAtencionService.cambiarClave({
                    'id': ctrl.centroEditar.Id_Centro_Atencion,
                    'nuevaPassword': ctrl.modificarClave.Clave_Autogestion
                }).$promise.then(function (data) {
                    sweetAlert('Cambio contraseña', 'Se ha modificado la contraseña para este centro de atención.', 'success');
                    ctrl.modificarClave = null;
                    $mdDialog.cancel();
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.cerrarModal = function () {
                ctrl.modificarClave = null;
                $mdDialog.destroy();
            }

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }

            ctrl.cargarDireccion = function (idSede){
                ctrl.CUITinfo.Sedes.forEach((sede)=>{
                    if(sede.Id_Sede == idSede){
                        ctrl.centroEditar.Direccion = {}
                        ctrl.centroEditar.Direccion.Sede_Domicilio = {}
                        ctrl.centroEditar.Direccion.Id_Sede = idSede
                        ctrl.centroEditar.Direccion.Id_Zona = sede.Id_Zona
                        ctrl.centroEditar.Direccion.Sede_Domicilio.Calle = sede.Sede_Domicilio.Calle
                        ctrl.centroEditar.Direccion.Sede_Domicilio.Altura = sede.Sede_Domicilio.Altura
                        ctrl.centroEditar.Direccion.Sede_Domicilio.CP = sede.Sede_Domicilio.CP
                    }
                })
            }

            function validarSede(centro) {
                if (centro.Direccion.Sede_Domicilio.Calle.trim().length === 0) {
                  ctrl.errores.calle = true;
                  ctrl.errores.altura = false;
                } else if (centro.Direccion.Sede_Domicilio.Altura.trim().length === 0) {
                  ctrl.errores.calle = false;
                  ctrl.errores.altura = true;
                } else {
                  ctrl.errores.calle = false;
                  ctrl.errores.altura = false;
                }
              }
              
              ctrl.editarSede = function () {
                validarSede(ctrl.centroEditar);
              
                if (!ctrl.errores.calle && !ctrl.errores.altura) {
                  centrosAtencionService.updateSede({
                    'id': ctrl.centroEditar.Direccion.Id_Sede,
                    'cuit': ctrl.CUITinfo.CUIT
                  }, ctrl.centroEditar.Direccion).$promise.then(function (data) {
                    sweetAlert('Modificar Sede', 'Se ha modificado la sede correctamente', 'success');
                    ctrl.buscarCUIT(ctrl.CUITinfo.CUIT, ctrl.centroEditar);
                    $mdDialog.cancel();
                  }).catch(function (error) {
                    utilsService.errores(error);
                  });
                }
              };
              
              ctrl.guardarSede = function () {
                validarSede(ctrl.centroEditar);
              
                if (!ctrl.errores.calle && !ctrl.errores.altura) {
                  centrosAtencionService.saveSede({ 'cuit': ctrl.CUITinfo.CUIT }, ctrl.centroEditar.Direccion).$promise.then(function (res) {
                    sweetAlert("Alta Sede", "La sede se registró correctamente", "success");
                    ctrl.centroEditar.Sede.Id_Sede = res.Data.Id;
                    ctrl.centroEditar.Direccion.Id_Sede = res.Data.Id;
                    ctrl.buscarCUIT(ctrl.CUITinfo.CUIT, ctrl.centroEditar);
                  }).catch(function (req) {
                    utilsService.errores(req);
                  });
                }
              };

            ctrl.obtenerZonas = function (){
                centrosAtencionService.getZonas().$promise.then(function (res){
                    ctrl.zonas = res.Data
                }).catch(function (error){
                    utilsService.errores(error)
                })
            }
        }
    ],
    template: require('./centrosAtencionModificar.html')
});


// WEBPACK FOOTER //
// ./app/components/centrosAtencion/centrosAtencionModificarComponent.js